import {
  Typography,
} from "@material-tailwind/react";
import React, { useState } from 'react';
import icon from '../assets/pad-pro-contact-us.png';

export default function ContactSectionA() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Full name is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email address is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Create email content
      const subject = `Contact Form Submission from ${formData.fullName}`;
      const body = `Hello PADPro Team,

You have received a new message through your website contact form.

Contact Details:
• Name: ${formData.fullName}
• Email: ${formData.email}

Message:
${formData.message}

---
This message was sent from the PADPro website contact form.
Please respond directly to the sender's email address: ${formData.email}

Best regards,
PADPro Website Contact System`;

      // Create mailto link
      const mailtoLink = `mailto:padproadult@yahoo.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      
      // Open default mail client
      window.location.href = mailtoLink;
      
      // Reset form on success
      setFormData({
        fullName: '',
        email: '',
        message: ''
      });
      
      // Show success message
      alert('Your default email client should now open with a pre-filled message. Please send the email to complete your submission. Thank you!');
      
    } catch (error) {
      alert('There was an error processing your request. Please try again or contact us directly at padproadult@yahoo.com');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            className="w-full h-full object-cover"
            src={icon}
            alt="Contact hero background"
          />
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 lg:py-24">
          <div className="max-w-3xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white mb-4 sm:mb-6 newsreader">
              Contact Us
            </h1>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-black mb-3 sm:mb-4 newsreader">
              We'd love to hear from you!
            </h2>
            <p className="text-base sm:text-lg text-black/90 mb-2 newsreader leading-relaxed">
              We're here to help you connect, ask questions, and take the next step in joining the PADPro community.
            </p>
            <p className="text-base sm:text-lg text-black/90 newsreader leading-relaxed">
              Whether you're looking to enroll, schedule a visit, or simply learn more, our team is ready to assist.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="overflow-hidden bg-gray-50 py-8 sm:py-12 md:py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <main className="mx-auto max-w-7xl">
            <div className="pt-6 sm:pt-8 md:pt-12 grid grid-cols-1 gap-6 sm:gap-8 md:gap-10 lg:gap-8 lg:grid-cols-2">
              
              {/* Contact Information - Left Side */}
              <div data-aos="fade-right" data-aos-duration="2000" className="space-y-6 sm:space-y-8 order-2 lg:order-1">
                
                {/* Hours of Operation */}
                <div>
                  <Typography variant="h5" className="text-green-500 mb-3 sm:mb-4 font-semibold text-lg sm:text-xl">
                    Hours of Operation
                  </Typography>
                  <div className="space-y-1">
                    <Typography color="gray" className="text-sm sm:text-base">
                      Monday - Friday
                    </Typography>
                    <Typography color="gray" className="text-sm sm:text-base">
                      08:00 AM - 04:00 PM
                    </Typography>
                    <Typography color="gray" className="text-sm sm:text-base">
                      Closed Saturday and Sunday
                    </Typography>
                  </div>
                </div>

                {/* Team Contact */}
                <div>
                  <Typography variant="h5" className="text-green-500 mb-3 sm:mb-4 font-semibold text-lg sm:text-xl">
                    Team Contact
                  </Typography>
                  <div className="space-y-1">
                    <Typography color="gray" className="text-sm sm:text-base font-medium">
                      Randy D. Garcia
                    </Typography>
                    <Typography color="gray" className="text-sm sm:text-base">
                      Executive Director
                    </Typography>
                  </div>
                </div>

                {/* Email Us */}
                <div>
                  <Typography variant="h5" className="text-green-500 mb-3 sm:mb-4 font-semibold text-lg sm:text-xl">
                    Email Us
                  </Typography>
                  <Typography color="gray" className="text-sm sm:text-base">
                    <a 
                      href="mailto:padproadult@yahoo.com"
                      className="hover:text-green-500 transition-colors break-all sm:break-normal"
                    >
                      padproadult@yahoo.com
                    </a>
                  </Typography>
                </div>

                {/* Call Us */}
                <div>
                  <Typography variant="h5" className="text-green-500 mb-3 sm:mb-4 font-semibold text-lg sm:text-xl">
                    Call Us
                  </Typography>
                  <div className="space-y-1">
                    <Typography color="gray" className="text-sm sm:text-base">
                      <a 
                        href="tel:+14083470402"
                        className="hover:text-green-500 transition-colors"
                      >
                        Tel #: (408) 347-0402
                      </a>
                    </Typography>
                    <Typography color="gray" className="text-sm sm:text-base">
                      <a 
                        href="tel:+14083470403"
                        className="hover:text-green-500 transition-colors"
                      >
                        Fax #: (408) 347-0403
                      </a>
                    </Typography>
                  </div>
                </div>

                {/* Visit Us */}
                <div>
                  <Typography variant="h5" className="text-green-500 mb-3 sm:mb-4 font-semibold text-lg sm:text-xl">
                    Visit Us
                  </Typography>
                  <div className="space-y-1">
                    <Typography color="gray" className="text-sm sm:text-base font-medium">
                      Address:
                    </Typography>
                    <Typography color="gray" className="text-sm sm:text-base leading-relaxed">
                      1333 Piedmont Road #109<br className="sm:hidden" />
                      <span className="hidden sm:inline"> </span>
                      San Jose CA 95132
                    </Typography>
                  </div>
                </div>
              </div>

              {/* Drop Us a Line Form - Right Side */}
              <div data-aos="fade-left" data-aos-duration="2000" className="order-1 lg:order-2">
                <div className="mb-4 sm:mb-6">
                  <Typography variant="h4" color="blue-gray" className="mb-3 sm:mb-4 newsreader text-2xl sm:text-3xl md:text-4xl">
                    Drop us a line
                  </Typography>
                  <Typography color="gray" className="mb-2 font-normal newsreader text-sm sm:text-base leading-relaxed">
                    We're here to help! If you have any questions, comments, or feedback, please feel free to reach out to us.
                  </Typography>
                  <Typography color="gray" className="mb-6 sm:mb-8 font-normal newsreader text-sm sm:text-base leading-relaxed">
                    Fill out the form below or use the contact information provided, and we'll get back to you as soon as possible.
                  </Typography>
                </div>
                
                <div className="bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow-lg">
                  <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
                    
                    {/* Full Name Field */}
                    <div>
                      <label htmlFor="fullName" className="block text-sm sm:text-base font-medium text-gray-700 mb-2">
                        Full Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="fullName"
                        name="fullName"
                        autoComplete="name"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        placeholder="e.g. John Doe"
                        className={`w-full px-4 sm:px-5 py-3 sm:py-4 border rounded-md text-sm sm:text-base focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 ${
                          errors.fullName ? 'border-red-500 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                      />
                      {errors.fullName && (
                        <p className="mt-2 text-sm text-red-500 flex items-center gap-1">
                          <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          {errors.fullName}
                        </p>
                      )}
                    </div>

                    {/* Email Field */}
                    <div>
                      <label htmlFor="email" className="block text-sm sm:text-base font-medium text-gray-700 mb-2">
                        Email Address <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        autoComplete="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="e.g. name@example.com"
                        className={`w-full px-4 sm:px-5 py-3 sm:py-4 border rounded-md text-sm sm:text-base focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 ${
                          errors.email ? 'border-red-500 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                      />
                      {errors.email && (
                        <p className="mt-2 text-sm text-red-500 flex items-center gap-1">
                          <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          {errors.email}
                        </p>
                      )}
                    </div>
                    
                    {/* Message Field */}
                    <div>
                      <label htmlFor="message" className="block text-sm sm:text-base font-medium text-gray-700 mb-2">
                        Message <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        rows="5"
                        value={formData.message}
                        onChange={handleInputChange}
                        placeholder="Tell us how we can help you..."
                        className={`w-full px-4 sm:px-5 py-3 sm:py-4 border rounded-md text-sm sm:text-base focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 resize-vertical min-h-[120px] ${
                          errors.message ? 'border-red-500 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                      />
                      {errors.message && (
                        <p className="mt-2 text-sm text-red-500 flex items-center gap-1">
                          <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          {errors.message}
                        </p>
                      )}
                    </div>
                    
                    {/* Submit Button */}
                    <div>
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full py-3 sm:py-4 px-6 rounded-md text-white font-medium text-sm sm:text-base transition-all duration-200 flex items-center justify-center gap-2 ${
                          isSubmitting
                            ? 'bg-gray-400 cursor-not-allowed'
                            : 'bg-red-500 hover:bg-red-600 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 hover:scale-105'
                        }`}
                      >
                        {isSubmitting ? (
                          <>
                            <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            SUBMITTING...
                          </>
                        ) : (
                          <>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            SUBMIT
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}